import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  { label: 'S.N', value: 'id' },
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Contact',
    value: 'mobile',
  },
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Supply chain',
    value: 'franchises',
  },
  {
    action: ['edit'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
